export default __webpack_public_path__ + "static/media/smallMockup5.4b44dd09.jpg";